import { stringArrayToObject } from '../../utils/array';

import { loadLastProducts } from '../../services/DatabaseService';

/* ------------- actions ------------- */
export const actions = stringArrayToObject(
  [
    'CLEAR',
    'LOAD_START',
    'LOAD_SUCCESS',
    'LOAD_FAILURE',
  ],
  '@@LAST_PRODUCTS',
);

const privateActionCreators = {
  loadStart(page, { search }) {
    return {
      type: actions.LOAD_START,
      payload: { page, search },
    };
  },
  loadSuccess({
    list, limit, page, totalPages, total,
  }) {
    return {
      type: actions.LOAD_SUCCESS,
      payload: {
        list, limit, page, totalPages, total,
      },
    };
  },
  loadFailure(err) {
    return {
      type: actions.LOAD_FAILURE,
      payload: { err },
    };
  },
};

export const actionCreators = {
  clear() {
    return {
      type: actions.CLEAR,
    };
  },
  load(page = 1, options = {}) {
    return async (dispatch) => {
      dispatch(privateActionCreators.loadStart(page, options));
      const response = await loadLastProducts(page, options);
      if (response.ok) {
        dispatch(privateActionCreators.loadSuccess(response));
      } else {
        dispatch(privateActionCreators.loadFailure(response.error));
      }
    };
  },
  changePagination(limit = 10, { search = null }) {
    return actionCreators.load(1, { limit, search });
  },
};



// WEBPACK FOOTER //
// ./src/redux/LastProducts/actions.js